import { Address4, Address6 } from 'ip-address';

export const checkIsValidIPv4 = prefix => {
  const addressIpv4 = new Address4(prefix);
  const isValidIpv4 = addressIpv4.isValid();
  return isValidIpv4;
};

export const checkIsValidIPv6 = prefix => {
  const addressIpv6 = new Address6(prefix);
  const isValidIpv6 = addressIpv6.isValid();
  return isValidIpv6;
};

export const checkIsValidIP = prefix => {
  return checkIsValidIPv4(prefix) || checkIsValidIPv6(prefix);
};

export const convertPrefixToDecimalRange = prefix => {
  const addressIpv4 = new Address4(prefix);
  const isValidIpv4 = addressIpv4.isValid();
  const addressIpv6 = new Address6(prefix);
  const isValidIpv6 = addressIpv6.isValid();
  let startAddressDecimalNumber = BigInt(0);
  let endAddressDecimalNumber = BigInt(0);

  if (isValidIpv4) {
    startAddressDecimalNumber = BigInt(
      addressIpv4
        .startAddress()
        .bigInteger()
        .toString()
    );
    endAddressDecimalNumber = BigInt(
      addressIpv4
        .endAddress()
        .bigInteger()
        .toString()
    );
  }

  if (isValidIpv6) {
    startAddressDecimalNumber = BigInt(
      addressIpv6
        .startAddress()
        .bigInteger()
        .toString()
    );
    endAddressDecimalNumber = BigInt(
      addressIpv6
        .endAddress()
        .bigInteger()
        .toString()
    );
  }

  return {
    startAddressDecimalNumber,
    endAddressDecimalNumber
  };
};

export const sortPrefixByAscending = (prefixA, prefixB) => {
  const prefixDecimalRangeA = convertPrefixToDecimalRange(prefixA);
  const prefixDecimalRangeB = convertPrefixToDecimalRange(prefixB);

  if (
    prefixDecimalRangeA.startAddressDecimalNumber >
    prefixDecimalRangeB.startAddressDecimalNumber
  ) {
    return 1;
  } else if (
    prefixDecimalRangeA.startAddressDecimalNumber <
    prefixDecimalRangeB.startAddressDecimalNumber
  ) {
    return -1;
  } else {
    if (
      prefixDecimalRangeA.endAddressDecimalNumber >
      prefixDecimalRangeB.endAddressDecimalNumber
    ) {
      return -1;
    } else if (
      prefixDecimalRangeA.endAddressDecimalNumber <
      prefixDecimalRangeB.endAddressDecimalNumber
    ) {
      return 1;
    } else {
      return 0;
    }
  }
};

export const sortPrefixByDescending = (prefixA, prefixB) => {
  const prefixDecimalRangeA = convertPrefixToDecimalRange(prefixA);
  const prefixDecimalRangeB = convertPrefixToDecimalRange(prefixB);

  if (
    prefixDecimalRangeA.startAddressDecimalNumber >
    prefixDecimalRangeB.startAddressDecimalNumber
  ) {
    return -1;
  } else if (
    prefixDecimalRangeA.startAddressDecimalNumber <
    prefixDecimalRangeB.startAddressDecimalNumber
  ) {
    return 1;
  } else {
    if (
      prefixDecimalRangeA.endAddressDecimalNumber >
      prefixDecimalRangeB.endAddressDecimalNumber
    ) {
      return 1;
    } else if (
      prefixDecimalRangeA.endAddressDecimalNumber <
      prefixDecimalRangeB.endAddressDecimalNumber
    ) {
      return -1;
    } else {
      return 0;
    }
  }
};

export const checkIsValidSubBlock = (val, prefixList) => {
  const isValidIp = checkIsValidIP(val);

  if (!isValidIp) return false;

  const inputtedPrefixDecimalNumber = convertPrefixToDecimalRange(val);

  const prefixDecimalNumberList = prefixList.map(prefix =>
    convertPrefixToDecimalRange(prefix)
  );

  return prefixDecimalNumberList.some(prefix => {
    return (
      inputtedPrefixDecimalNumber.startAddressDecimalNumber >=
        prefix.startAddressDecimalNumber &&
      inputtedPrefixDecimalNumber.endAddressDecimalNumber <=
        prefix.endAddressDecimalNumber
    );
  });
};

export const checkIsASNumber = value => {
  const ASNumberRegex = new RegExp('^(as)?([0-9]+)$', 'i');

  if (!value.match(ASNumberRegex)) return false;

  const ASNumber = value.match(ASNumberRegex)[2];

  // ASNumber needs to be changed to number type, otherwise it is string type
  const isInAsNumberRange = validateIsInASNumberRange(+ASNumber);

  if (!isInAsNumberRange) return false;

  return true;
};

const validateIsInASNumberRange = number => {
  if (number > 0 && number < 4294967295 && number !== 65535) return true;

  return false;
};

export const normalizeASN = val => {
  const isAllDigital = val.match(/^\d+$/);
  if (isAllDigital) return `AS${val}`;
  return val;
};

export const getPureNumberFromASN = val => {
  const isNumber = typeof val === 'number' || val.match(/^\d+$/);
  if (isNumber) return Number(val);

  return Number(val.replace(/^as/i, ''));
};

export const sortASNByAscending = (asnA, asnB) => {
  if (getPureNumberFromASN(asnA) > getPureNumberFromASN(asnB)) {
    return 1;
  } else if (getPureNumberFromASN(asnA) < getPureNumberFromASN(asnB)) {
    return -1;
  } else {
    return 0;
  }
};

export const sortASNByDescending = (asnA, asnB) => {
  if (getPureNumberFromASN(asnA) > getPureNumberFromASN(asnB)) {
    return -1;
  } else if (getPureNumberFromASN(asnA) < getPureNumberFromASN(asnB)) {
    return 1;
  } else {
    return 0;
  }
};
